export const alphaNumericValidator = value => {
    if (!/^[a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{};:'",<>.\/?|\\~`]{1,255}$/.test(value))
        return "Invalid input.";
    return false;
};

export const alphaNumericNoSpacesValidator = value => {
    if (!/^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};:'",<>.\/?|\\~`]{1,255}$/.test(value))
        return "Invalid input.";
    return false;
};

export const alphaNumericEmptyValidator = value => {
    if (!/^[a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{};:'",<>.\/?|\\~`]{0,255}$/.test(value))
        return "Invalid input.";
    return false;
};

export const alphaNumericCodeValidator = value => {
    if (!/^[A-Za-z0-9]{3,6}$/.test(value))
        return "Invalid input.";
    return false;
};

export const alphaNumericCodeEmptyValidator = (value, minInput = 0, maxInput = 15) => {
    const regex = new RegExp(`^[A-Za-z0-9\\-/()]{${minInput},${maxInput}}$`);
    if (!regex.test(value))
        return "Invalid input.";
    return false;
};
export const numberValidator = value => {
    if (!/^(0|[1-9]\d*)?(\.\d+)?(?<=\d)$/.test(value))
        return "Invalid number.";
    return false;
};

export const phoneNumberValidator = value => {
    if (!/^\+?(\d{1,3})?[-.\s]?(\(?\d{1,4}\)?)?[-.\s]?(\d{1,4})[-.\s]?(\d{1,4})[-.\s]?(\d{1,9})?$/.test(value))
        return "Invalid phone number.";
    return false;
};

export const emailValidator = value => {
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value))
        return "Invalid email address.";
    return false;
};

export const postcodeValidator = value => {
    if (!/^[A-Za-z0-9 \-/]{0,10}$/.test(value))
        return "Invalid postcode.";
    return false;
};

export function checkAllValid(obj) {
    return Object.values(obj).every(value => {
        if (typeof value === 'object' && value !== null) {
            return checkAllValid(value);
        }
        return value;
    });
}